import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { AuthService } from './../../shared/models/auth.service';
import { CompanyModel } from "./../../company/models/company.model";
import { DataListModel, ApplicationRouteURL } from '../../shared/config';
import { Observable } from 'rxjs/Observable';
import { TermsConditionActivityLog } from '../../termsconditionpopup/models/terms-condition.model';
import { TermsAndConditionsService } from '../models/terms-conditions.service';

@Component({
  selector: "wego-tc-activity-popup",
  template: require('../views/tc-activity-log-popup.component.html'),
  providers: [
    TermsAndConditionsService
  ]
})

export class TCActivityPopupComponent implements OnInit {
  urlctgUpdate: string;
  urlBookingInformation: string;
  urlDriverInfo: string;
  DataListModel: DataListModel = new DataListModel();
  TandCActivityLog: TermsConditionActivityLog[];
  isLoading: boolean;
  apiErrorMsg: string;
  LblIcon: string = "fa fa-plus-square";
  termsConditionhashId: string;
  TermsAndConditionName: string;

  @ViewChild('tcActivityModel') public tcActivityModel: any;

  constructor(
    private TermsAndConditionService: TermsAndConditionsService,
    private authService: AuthService
  ) { }

  ngOnInit() {

    this.urlDriverInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_PERSON_UPDATE
    );
    this.urlBookingInformation = this.authService.GetURL(ApplicationRouteURL.URL_BOOKING_INFORMATION);

    this.urlctgUpdate = this.authService.GetURL(ApplicationRouteURL.URL_CONTRACT_TYPE__GROUP_UPDATE);

  }

  public show(termsConditionhashId: string, TermsAndConditionName: string): void {
    this.termsConditionhashId = termsConditionhashId;
    this.TermsAndConditionName = TermsAndConditionName;
    this.GetTAndCActivityList();
    this.tcActivityModel.show();
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetTAndCActivityList();
  }

  private GetTAndCActivityList() {
    this.isLoading = true;
    this.TermsAndConditionService.GetTermsAndConditionActivityList(this.termsConditionhashId, this.DataListModel)
      .subscribe(
        res => {
          this.TandCActivityLog = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.TermsAndConditionService
      .ExportTermsAndConditionActivityList(this.termsConditionhashId, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = "TermsAndConditionActivityLog" + new Date().toISOString() + ".csv";
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetTAndCActivityList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetTAndCActivityList();
  }

  public hide(): void {
    this.tcActivityModel.hide();
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/termsandcondition/components/tc-activity-log-popup.component.ts